function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.26,136l-87.61-.14s4.36-5.66,9.17-6.36c0,0,9.38-27.79,25-28,14.53-.16,20.33,17.13,20.33,17.13s6.75-7.74,13.18-4.18,10.06,13.71,10.06,13.71S157.64,132.06,160.26,136Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,155.57l110.79.17s0-7.08-15.25-8.49c0,0-13.89-31-35.17-26.83-13.25,2.57-20.05,20.75-20.05,20.75s-10-14.33-18-11.58-12.79,18-12.79,18S270.3,151.57,269,155.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.53,76.51l75.33.12S278.76,70,275.6,70s-12.35-22.24-24.13-21.31-18.06,17.46-18.06,17.46S219.09,61.64,210.53,76.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.12,99.72l64.42.1s-3.19-4.17-6.72-4.7c0,0-6.84-20.46-18.34-20.62-10.69-.15-15,12.55-15,12.55s-4.95-5.71-9.68-3.11S391.38,94,391.38,94,386.06,96.86,384.12,99.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.43,180.22a134.73,134.73,0,0,1-25.86,79.59v0a135.39,135.39,0,1,1-109.51-215c3.71,0,7.39.14,11,.44a134.55,134.55,0,0,1,59.23,19.19,136,136,0,0,1,36.16,32.06,134.9,134.9,0,0,1,29,83.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.28,244.12c-1.7,4.55,1.14,4.74,1.33,6.64s0,5.49-5.5,11-14.6,4.36-16.49,6.64-5.12,11.94-9.67,15.17-5.31,1.32-11.76,2.65-11.38,9.67-13.27,13.65.38,10.62-4.17,10.81-6.64-9.67-10.81-15-5.5-10.05-6.83-16.3.76-19.34,0-24.46-14.41-14.22-19.34-20.48S492,215.68,492.4,211.51a17,17,0,0,1,5.68-10.43c2.28-1.71,1.33-2.65,1.71-4.17s2.28-1.9,2.66-3.79-1.14-7.59-3-8.54-3.22,2.28-4.36,1.71-4.55-4.55-5.88-4.93-.94,2.47-2.84-1.14S483.49,167.52,482,166s-2.66,2.66-6.26,0-5.12-7.77-6.63-8.53-3.61.19-5.17-2.84,1.37-8.54,0-8-4.31,4.93-5.07.76,3.79-18.2,3-25.78,1.9-15.55,7.21-22c0,0,.75-4.17,1.51-6.82s17.07-13.28,19-16.31c.79-1.27,1.06-3.25,1.34-5.39a134.73,134.73,0,0,1,80.16-26.27c3.71,0,7.39.14,11,.44.12.17.25.34.38.5,1.64,2.09,3.41,3.42,8.22,5.19s5.93,4,4.93,5.94-2.66,2.27-4.55,2.4-3.67-.89-5.69.38-4,8.09-6.7,8.47-7.33-6.07-8.35-8,2.28-5.94.73-7.83-4.26-1.52-8.56-1.9-14.29,1.27-13.91,2.91,14.66-.26,15,3-10.49,8.85-12.38,8.34S546.81,61,544,60.58s-5,1.9-6.8,2.15-3.81-1.89-6.47-1.39-3.29,2.78-4.68,3.67-4.67.88-5.05,2.9,4.17,3.17,5.31,4.43-1.4,5.56-.26,6.44,8.22-5.3,10-6.82,3.28-8.09,7.08-8,5.05,6.57,6.32,7.2,4-1.52,8.22-.63,7.07,10,7.83,12.77,2.53,5.56,1,6.7-8.34-.76-9.22-2.53,4.55-4.43,4.17-5.06-3.54-1.52-5.19-.53-2.4,3.06-4.17,3.57-6.44-4.81-7.71-3.29,1.27,6.32,2.53,7.46,5.94,1.76,6.32,3-3.16,4-7.46,3.79-7.83-3.54-9.48-2.15-.76,5.06-1.9,6.32-7.33.38-10.36,3.67-4.42,8.21-7.46,11-4.42-.75-8.47,3.17-4.67,12.64-4.8,15.67,0,5.43-1,5-2.4-3-2.78-4.67.88-4.43.88-5.44-5.81-6.19-9.23-6.7-6.44,2.28-9,4.3-7.08,1.65-8.72,3.29-2.91,16.18-1.65,19.59,2.91,3.41,7,1.64,1.77-5.18,4.17-4.42a5.65,5.65,0,0,1,3.66,5.31c0,2-4.8,6.82-4.17,8.21s4.81-.25,6.83.38,3,1.9,2.4,7.08-.25,9.23,2.78,10.94,4.74-2.47,6.07-1.9,3.22,3.6,5.12,3.41.95-1.89,4.55-3,2.27-1.9,3-4.17,3-4.17,5.5-3,.76,2.85,1,4.74,4.55,2.09,8,3.23,5.31,0,12.14,2.27,7.2,9.1,10.05,10.24,12.32-.76,19.15,4.17,4.93,14,8.34,16.69,16.12,6.26,21,7.2,5.68-2.46,9.67-1.51,6.25,2.08,7.58,7.58C616.81,229.43,602,239.57,600.28,244.12Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.4,147.17c.13,1.07,3.29,1.52,7.08,3.66s5.18,8.47,7.2,8.35,1.39-3,2.15-3.8,2-2.4,0-4-4-5.18-7.68-5.69-4.33-2-6-1.89A2.86,2.86,0,0,0,498.4,147.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.26,157.79c-.57,1.55,0,2.65,4,3.66s7.84-1,6.58-1.83-3.16-.44-2.41-1.83.5-3.42-2.78-3S519.76,156.4,519.26,157.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.41,158.22c-1.37.2-2.14,2.6-.75,4.12s1.39,1.26,3,0,4.17-1.9,3.54-3.16S534.81,158,533.41,158.22Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.41,163.38c.62-1.89,3.79,0,5.18,2s.76,4.93,0,7.08-1.26,4.68-3,3.67.13-4.05-.13-5.82S543.91,164.93,544.41,163.38Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.89,57.93c-.66,1.59,2.4,2.15,4.17,3.16s3.16,1.64,4.17,0-.38-3.54-1.77-3.92S599.52,56.41,598.89,57.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.78,72.72c1.17,1.23,3.16,1,4.55,2.78s.89,4.8,2.66,5.69,3,0,3.16-1.27-2.53-4.42-2.28-5,3.67.88,4.43,2.78-.76,4.55,1,5,1.39-1.77,2.15-2.27,2.4-.26,2.27-1.77-2.15-4.81-3.79-5.94-2.91-2.4-5.69-3-5.43-.12-6.83,1S622.06,72,622.78,72.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.47,96.54a2.24,2.24,0,0,1-.71,1.33c-2.66,1.9-5.82-4.68-9.48-5.94S662,86,661.21,87s-.51,2.4-1.65,4-2.78,1.27-3.53,4.43,3.53,9,2.53,10.87-2.28,1.26-4.31,1.14-1.64,1.64-4.29.88-.38-4-4.55-8-5.57-4.68-4.67-6.45-.39-4.29,1.51-4.55,3.41,2.53,4.67,3.29,2.91-1.52,3-3.54-4.43-4.8-6.07-6.37-1.77-7.28-1.14-8.42,2.53-.76,3-3.54c.29-1.63-2.29-4.36-4.48-6.34A136,136,0,0,1,677.47,96.54Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.35,209.87c.38-4.05-1.64-4.3.38-11.76s-2.15-15.42-3.67-17.06-4.8-1.14-7.46.5-.75,2.91-2.53,3.54-3.53-.38-5.18-.25-3.16,4.29-6.7,4.17-5.81-5.18-8.46-8.79-8.1-5.87-9.86-10.3,1.64-11.25.88-16.43-4.17-4.05-4.8-7,.5-1.52,1.39-4.3-1-4.3.76-9.1,4.93-7.21,4.17-9.35-3.16-5.69-3.29-8.21,2.4-2.41,7.2-6,6.07-3.29,9.74-2a51.86,51.86,0,0,0,8.09,2.28c2.15.38,5.06,5.94,5.94,5.69s1-1.9,1.39-4.3a5.34,5.34,0,0,1,1.58-2.72,135.44,135.44,0,0,1-5.35,151.26C693.47,240.13,696,213.91,696.35,209.87Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.76,103.37l-.22-.72,1-.28.21.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.91,133.21l-1.45-1.39.52-.54,1.45,1.4ZM666,130.45l-1.49-1.34.5-.56q.75.66,1.5,1.35Zm-3-2.66-1.53-1.3.48-.58,1.54,1.31Zm-3.09-2.57c-.52-.42-1-.84-1.57-1.25l.46-.59,1.58,1.25Zm-3.17-2.47-1.61-1.19.44-.61,1.62,1.2Zm-3.24-2.36-1.66-1.15.43-.62,1.66,1.15Zm-3.32-2.26c-.57-.37-1.13-.74-1.69-1.09l.4-.64,1.7,1.1Zm-3.4-2.16-1.72-1,.39-.65,1.73,1Zm-3.45-2-1.75-1,.36-.66,1.76,1ZM639.8,112l-1.78-.93.34-.66c.6.3,1.2.61,1.79.93Zm-3.58-1.83q-.9-.45-1.8-.87l.32-.68,1.82.88Zm-3.62-1.72-1.84-.83.31-.68,1.84.82Zm-3.68-1.62c-.62-.27-1.24-.52-1.86-.77l.29-.7q.93.38,1.86.78Zm-3.72-1.52-1.87-.71.27-.7,1.88.72Zm-3.74-1.4-1.9-.67.25-.71,1.9.67Zm-3.79-1.31-1.91-.61.23-.72,1.91.62Zm-125,0-.2-.72,1.95-.53.19.73Zm3.89-1-.18-.73,2-.48.18.73Zm117.32-.14-1.93-.57.21-.72,1.93.57Zm-113.4-.8-.17-.73,2-.45.16.73ZM610,100.27c-.65-.17-1.29-.35-1.94-.51l.19-.73,1.94.52ZM504.37,99.7l-.15-.73,2-.42.15.74Zm101.75-.44-2-.47.17-.73c.65.16,1.31.31,2,.48Zm-97.8-.37-.15-.74,2-.38.14.74Zm93.9-.54-2-.43.16-.73,2,.43Zm-90-.21-.13-.74,2-.35.12.74Zm86-.62-2-.38.14-.74c.66.13,1.32.25,2,.39Zm-82-.07-.13-.74,2-.33.11.74Zm4-.63-.11-.75,2-.29.1.74Zm74.12,0-2-.33.12-.74,2,.33Zm-70.13-.54-.11-.74,2-.27.09.75Zm66.16-.11-2-.29.11-.74,2,.29Zm-62.17-.4L528.1,95l2-.23.09.74Zm58.19-.16-2-.25.09-.74,2,.25Zm-54.19-.3-.08-.74,2-.21.07.75Zm50.2-.18-2-.21.07-.75,2,.21Zm-46.2-.21-.06-.75,2-.17.06.74Zm42.19-.19-2-.17.06-.75,2,.17Zm-38.18-.15-.05-.74,2-.15.05.75Zm34.17-.17-2-.13,0-.75,2,.13Zm-30.15-.1-.05-.75,2-.11,0,.75Zm26.14-.15-2-.09,0-.75,2,.1Zm-22.12-.06,0-.75,2-.08,0,.75Zm18.1-.1q-1,0-2-.06v-.75c.67,0,1.35,0,2,.06Zm-14.08,0,0-.75,2,0v.75Zm10.06-.06-2,0v-.75l2,0Zm-6,0V93.1l2,0v.75Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.1,135.42l-.69-.71.53-.53.7.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.15,184.91a4.84,4.84,0,0,1-.09-1.09h.75a3.93,3.93,0,0,0,.07.91Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.88,181.84l-.75,0c0-.54.07-1.14.11-1.8v-.21l.75.05v.2C521,180.7,520.91,181.3,520.88,181.84Zm.25-4-.75-.05c0-.63.08-1.29.12-2l.74,0C521.21,176.54,521.17,177.21,521.13,177.84Zm.21-4-.75,0c0-.64,0-1.31.06-2l.75,0C521.39,172.51,521.36,173.18,521.34,173.83Zm.1-4h-.75c0-.51,0-1,0-1.55v-.45h.75v.45C521.45,168.77,521.45,169.29,521.44,169.8Zm-.76-4c0-.65,0-1.32-.06-2l.75,0c0,.69,0,1.36.06,2Zm-.15-4c0-.65-.08-1.32-.13-2l.75-.06c.05.68.09,1.35.13,2Zm-.3-4c-.06-.65-.13-1.31-.2-2l.74-.09c.08.68.15,1.34.21,2Zm-.45-4c-.08-.65-.18-1.31-.28-2l.74-.11c.1.67.2,1.33.29,2Zm-.61-4c-.12-.65-.25-1.3-.38-2l.74-.15c.13.66.26,1.32.37,2Zm-.8-3.91c-.14-.65-.3-1.3-.46-1.95l.73-.18c.16.66.32,1.31.47,2Zm-1-3.88c-.18-.63-.37-1.27-.56-1.91l.71-.22c.2.64.39,1.29.57,1.93Zm-1.17-3.81q-.32-.94-.66-1.89l.71-.26c.23.64.45,1.27.66,1.91Zm-1.37-3.75c-.24-.62-.49-1.24-.76-1.85l.69-.29c.27.62.52,1.24.77,1.86Zm-1.57-3.67c-.28-.6-.56-1.2-.86-1.8l.67-.34c.3.61.59,1.22.87,1.82Zm-1.78-3.57c-.31-.58-.63-1.17-1-1.75l.65-.37c.34.59.67,1.17,1,1.76Zm-2-3.46c-.35-.56-.7-1.12-1.07-1.68l.63-.41c.37.56.73,1.13,1.08,1.7Zm-2.2-3.33c-.38-.54-.77-1.07-1.17-1.61l.6-.45c.41.54.8,1.08,1.19,1.63Zm-2.39-3.18c-.42-.52-.84-1-1.27-1.54l.57-.48c.44.51.86,1,1.28,1.55Zm-2.59-3c-.45-.49-.9-1-1.37-1.46l.54-.52q.71.73,1.38,1.47Zm-2.78-2.87c-.47-.46-.95-.91-1.45-1.36l.51-.56,1.47,1.38Zm-2.94-2.69c-.5-.43-1-.85-1.53-1.28l.48-.58c.52.43,1,.86,1.54,1.29Zm-3.09-2.51c-.53-.4-1.06-.8-1.61-1.19l.44-.61,1.62,1.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.27,103.88l-.83-.56.42-.62.83.56Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.27,180.48l-.55-.51s.23-.26.69-.73l.54.52C522.5,180.22,522.28,180.47,522.27,180.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.37,178.34l-.53-.54,1.47-1.4.52.54Zm2.94-2.76-.5-.56c.47-.43,1-.88,1.52-1.35l.49.57C528.29,174.71,527.78,175.15,527.31,175.58Zm3-2.66-.48-.57c.5-.42,1-.86,1.56-1.3l.47.58Zm3.12-2.56-.47-.59,1.6-1.26.46.6C534.51,169.53,534,170,533.47,170.36Zm3.19-2.48-.45-.6c.52-.4,1.07-.8,1.62-1.21l.45.6C537.72,167.08,537.18,167.48,536.66,167.88Zm3.25-2.4-.44-.61,1.66-1.17.43.62Zm3.31-2.31-.42-.62,1.68-1.13.41.63C544.32,162.42,543.77,162.8,543.22,163.17Zm3.36-2.23-.4-.63,1.71-1.09.4.64Zm3.42-2.15-.39-.63,1.74-1,.38.64Zm3.47-2.06-.38-.65,1.77-1,.36.65Zm3.52-2-.36-.66,1.78-1,.35.66Zm3.56-1.9-.35-.67,1.81-.92.34.67C561.74,152.23,561.14,152.54,560.55,152.85Zm3.6-1.82-.33-.67,1.83-.88.32.68Zm3.65-1.73-.31-.68,1.84-.84.31.69Zm3.69-1.64-.3-.69,1.86-.8.29.7Zm3.72-1.56-.28-.7,1.88-.75.27.7Zm3.76-1.47-.27-.71,1.9-.7.26.7C580.22,144.15,579.59,144.39,579,144.63Zm3.79-1.39-.25-.71,1.92-.66.24.71Zm3.82-1.29-.23-.72,1.93-.61.22.71Zm3.85-1.21-.21-.72,1.94-.57.21.72Zm3.88-1.12-.2-.72,2-.53.19.73Zm3.9-1-.18-.73,2-.48.17.73C599.52,138.27,598.86,138.43,598.21,138.6Zm3.93-.94-.17-.73,2-.44.16.74Zm4-.84-.15-.74,2-.39.14.74Q607.06,136.61,606.09,136.82Zm4-.76-.13-.74,2-.34.12.74Zm4-.66-.11-.74,2-.3.11.74Zm54.29-.3-2-.26.1-.75,2,.27ZM618,134.83l-.1-.75,2-.25.09.75Zm46.29-.24-2-.22.08-.74,2,.22ZM622,134.35l-.08-.75,2-.21.07.75Zm38.27-.18-2-.18.07-.75,2,.18ZM626.05,134l-.06-.75,2-.16,0,.74Zm30.23-.13-2-.14.05-.75,2,.14Zm-26.21-.18,0-.74c.67,0,1.34-.09,2-.12l0,.75Zm22.19-.08-2-.1,0-.75,2,.1Zm-18.16-.13,0-.75,2-.07,0,.75Zm14.13-.05-2-.06,0-.75,2,.06Zm-10.09-.07,0-.75c.68,0,1.35,0,2,0v.75C639.48,133.29,638.81,133.3,638.14,133.32Zm6.05,0-2,0v-.75l2,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.32 135.53 670.33 135.38 670.44 134.64 671.43 134.79 671.32 135.53",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567,202.65l-.74-.13s.06-.34.14-1l.74.1C567.07,202.3,567,202.65,567,202.65Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.37,199.62l-.75-.07c0-.59.1-1.26.14-2l.75,0C567.47,198.34,567.42,199,567.37,199.62Zm.22-4.07-.75,0c0-.64,0-1.31,0-2h.75C567.62,194.22,567.61,194.9,567.59,195.55Zm-.73-4.06c0-.66,0-1.33-.07-2l.75,0c0,.7.06,1.38.07,2Zm-.18-4c0-.66-.09-1.33-.15-2l.74-.07c.06.7.12,1.37.16,2Zm-.36-4c-.07-.66-.15-1.32-.25-2l.75-.11c.09.69.17,1.36.25,2Zm-.54-4c-.1-.66-.22-1.32-.34-2l.74-.13c.12.68.24,1.35.34,2Zm-.72-4c-.13-.65-.28-1.31-.43-2l.73-.17c.16.67.3,1.33.43,2Zm-.9-3.94c-.17-.64-.34-1.29-.52-1.95l.72-.2c.18.66.36,1.32.52,2Zm-1.08-3.89c-.2-.64-.4-1.28-.61-1.92l.71-.24c.21.65.42,1.3.61,1.94Zm-1.27-3.84c-.22-.62-.45-1.26-.7-1.89l.7-.27c.25.64.48,1.28.71,1.91ZM560.37,160c-.25-.61-.52-1.23-.79-1.85l.69-.31c.27.63.54,1.26.79,1.88Zm-1.62-3.69c-.28-.61-.58-1.21-.88-1.82l.67-.34c.31.62.6,1.23.89,1.84Zm-1.8-3.62q-.47-.88-1-1.77l.65-.37c.34.6.66,1.2,1,1.79Zm-2-3.52c-.34-.58-.69-1.15-1.05-1.73l.64-.39c.36.58.71,1.16,1.06,1.74Zm-2.14-3.42c-.36-.56-.74-1.12-1.13-1.68l.62-.42q.58.84,1.14,1.68Zm-2.3-3.32c-.39-.54-.8-1.08-1.21-1.62l.6-.45c.41.54.82,1.08,1.22,1.63Zm-2.46-3.2c-.41-.52-.84-1-1.28-1.56l.57-.48c.44.52.88,1,1.3,1.57Zm-2.6-3.08c-.44-.5-.9-1-1.36-1.5l.55-.51c.47.5.92,1,1.37,1.51Zm-2.75-3c-.46-.48-.94-1-1.42-1.44l.53-.53,1.43,1.44Zm-2.87-2.84c-.49-.45-1-.91-1.49-1.36l.5-.56,1.5,1.38Zm-3-2.7-1.55-1.3.48-.58,1.56,1.31Zm-3.12-2.57c-.52-.41-1-.83-1.59-1.24l.45-.59c.54.41,1.08.82,1.61,1.24Zm-3.21-2.44c-.54-.39-1.09-.79-1.65-1.17l.43-.62L531,122Zm-3.32-2.31q-.83-.57-1.68-1.11l.4-.63,1.7,1.11Zm-3.39-2.19-1.73-1,.38-.64,1.74,1Zm-3.48-2.06-1.76-1,.36-.65q.9.48,1.77,1Zm-3.54-1.94c-.59-.31-1.19-.62-1.8-.92l.34-.67c.61.3,1.21.61,1.81.93Zm-3.61-1.82-1.83-.87.32-.68,1.84.87Zm-3.67-1.71-1.85-.81.3-.69c.62.27,1.25.54,1.86.82ZM505.81,109l-1.88-.76.28-.7,1.88.77Zm-3.76-1.49-1.9-.71.26-.7,1.9.71Zm-3.8-1.39-1.91-.65.23-.71c.65.21,1.29.43,1.93.66Zm-3.84-1.28c-.63-.21-1.28-.41-1.93-.61l.23-.72,1.93.61Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.51 103.65 489.55 103.37 489.75 102.65 490.72 102.93 490.51 103.65",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.48,135.73l-.16-.74,1-.2.14.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.77,272.17l-.74-.12c.1-.65.21-1.31.31-2l.74.12C549,270.86,548.87,271.52,548.77,272.17Zm.65-3.91-.74-.13c.12-.65.23-1.31.36-2l.73.14C549.65,267,549.53,267.61,549.42,268.26Zm.73-3.9-.74-.14.39-2,.74.15Zm.8-3.88-.73-.16c.14-.65.28-1.3.43-1.94l.73.17C551.24,259.19,551.09,259.83,551,260.48Zm.88-3.86-.73-.18.48-1.93.72.18C552.14,255.33,552,256,551.83,256.62Zm1-3.85-.72-.19.51-1.92.72.2Zm1.05-3.82-.72-.21c.18-.64.36-1.27.55-1.91l.72.22C554.2,247.68,554,248.31,553.84,249Zm1.12-3.8-.71-.22c.19-.64.39-1.27.59-1.9l.72.23C555.35,243.89,555.16,244.52,555,245.15Zm1.21-3.77-.71-.24c.21-.63.42-1.26.64-1.89l.71.25C556.59,240.12,556.38,240.75,556.17,241.38Zm1.29-3.75-.71-.25.69-1.87.7.26C557.91,236.38,557.68,237,557.46,237.63Zm1.38-3.72-.7-.26.72-1.86.7.28Zm1.46-3.68-.69-.28c.25-.62.51-1.23.77-1.84l.69.29Zm1.55-3.64-.68-.31c.26-.61.54-1.21.81-1.81l.68.31Zm1.64-3.61-.68-.32c.28-.6.57-1.2.86-1.8l.67.33C564.05,221.78,563.77,222.38,563.49,223Zm1.72-3.57-.67-.33.9-1.78.67.34Zm1.81-3.52-.66-.36.94-1.75.66.36C567.65,214.72,567.33,215.3,567,215.89Zm1.9-3.48-.65-.37c.32-.58.65-1.16,1-1.73l.65.38Zm2-3.43-.65-.39c.34-.57.68-1.14,1-1.7l.64.39C571.58,207.84,571.24,208.41,570.91,209ZM573,205.6l-.63-.4c.35-.56.71-1.12,1.07-1.68l.63.41C573.68,204.48,573.33,205,573,205.6Zm2.16-3.32-.63-.42c.37-.56.75-1.11,1.12-1.65l.62.42Zm2.24-3.27-.62-.44,1.16-1.62.61.44C578.13,197.93,577.75,198.46,577.37,199Zm2.32-3.21-.6-.45c.4-.54.79-1.07,1.2-1.59l.59.45C580.48,194.74,580.08,195.26,579.69,195.8Zm2.4-3.15-.59-.47,1.24-1.55.58.47Zm2.49-3.09-.58-.48c.42-.51.85-1,1.28-1.52l.57.48C585.42,188.54,585,189.05,584.58,189.56Zm2.56-3-.57-.49c.44-.51.88-1,1.32-1.5l.56.5C588,185.54,587.58,186,587.14,186.54Zm2.64-3-.55-.5c.45-.5.9-1,1.35-1.46l.55.51Zm2.71-2.89-.54-.52c.46-.48.93-.95,1.39-1.42l.54.53Zm2.79-2.81-.53-.54c.48-.46,1-.93,1.43-1.38l.52.54C596.22,177,595.75,177.41,595.28,177.88Zm2.85-2.75-.51-.55,1.46-1.35.51.56Zm2.93-2.67-.5-.56,1.49-1.32.5.57Zm3-2.6-.48-.57c.51-.44,1-.86,1.52-1.28l.48.58Zm3.06-2.53-.47-.58c.51-.42,1-.83,1.55-1.24l.47.59Zm3.11-2.45-.45-.59,1.58-1.2.45.6Zm3.18-2.37-.44-.6,1.61-1.17.44.61Zm3.23-2.29-.43-.62c.55-.38,1.1-.76,1.65-1.12l.42.62C617.72,159.46,617.17,159.84,616.63,160.22Zm3.29-2.22-.42-.63,1.67-1.08.41.63C621,157.27,620.47,157.63,619.92,158Zm3.33-2.14-.39-.64,1.69-1,.39.64Zm3.39-2.06-.38-.65,1.72-1,.37.65Zm3.44-2-.37-.65,1.74-1,.36.66Zm3.48-1.9-.36-.66,1.77-.93.34.67Zm3.52-1.82-.34-.67,1.79-.88.33.67Zm3.56-1.73-.32-.68,1.81-.84.31.68Zm3.61-1.66-.31-.68,1.83-.8.3.69C645.47,144.17,644.86,144.44,644.25,144.71Zm3.64-1.57-.29-.69,1.85-.76.28.7Zm3.68-1.48-.27-.7,1.86-.71.26.7Zm3.71-1.39-.25-.71,1.88-.67.25.71C656.55,139.81,655.92,140,655.28,140.27ZM659,139l-.23-.71,1.89-.61.23.71Zm3.79-1.2-.22-.71c.67-.21,1.31-.39,1.92-.57l.2.72Zm3.81-1.09-.19-.72,1.94-.5.18.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.53,
    y: 274.2,
    width: 1,
    height: 0.75,
    transform: "translate(197.78 777.62) rotate(-81.76)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.46,274.63l-.72-.19c.17-.65.34-1.29.5-1.93l.72.18C548.81,273.33,548.64,274,548.46,274.63Zm.95-3.9-.73-.16c.14-.65.27-1.3.4-1.95l.73.14C549.69,269.42,549.56,270.07,549.41,270.73Zm.76-4-.75-.12c.11-.65.21-1.31.3-2l.74.1C550.37,265.46,550.27,266.12,550.17,266.78Zm.54-4-.75-.08c.08-.66.14-1.32.19-2l.75.06C550.85,261.47,550.78,262.14,550.71,262.8Zm.33-4-.74,0c0-.67.06-1.33.08-2l.75,0Q551.1,257.79,551,258.8Zm.13-4h-.75v-.5c0-.5,0-1,0-1.49h.75c0,.5,0,1,0,1.5Zm-.82-4c0-.66-.07-1.33-.11-2l.74-.05q.07,1,.12,2Zm-.28-4q-.09-1-.21-2l.75-.09c.08.67.15,1.33.21,2Zm-.46-4c-.1-.66-.2-1.32-.31-2l.74-.12c.11.65.21,1.32.31,2ZM549,239c-.13-.65-.26-1.3-.4-1.95l.73-.16c.14.65.28,1.31.4,2Zm-.84-3.89-.48-1.93.72-.19c.17.64.33,1.29.49,1.94Zm-1-3.85c-.18-.65-.37-1.28-.57-1.92l.72-.22c.2.64.38,1.28.57,1.93Zm-1.18-3.81c-.2-.64-.42-1.27-.64-1.89l.71-.25c.22.63.44,1.26.65,1.9Zm-1.32-3.76c-.24-.63-.48-1.24-.73-1.86l.7-.28c.25.62.49,1.25.73,1.88Zm-1.48-3.7c-.26-.62-.53-1.23-.79-1.83l.68-.31c.27.61.54,1.22.8,1.85Zm-1.62-3.65c-.28-.6-.57-1.2-.86-1.8l.68-.33c.29.6.58,1.2.86,1.82Zm-1.75-3.58c-.3-.6-.61-1.19-.92-1.77l.66-.35c.31.58.62,1.18.93,1.78Zm-1.87-3.52-1-1.74.64-.37q.51.85,1,1.74Zm-2-3.46c-.34-.58-.69-1.15-1-1.7l.64-.4c.35.56.7,1.13,1,1.72Zm-2.1-3.39c-.37-.57-.73-1.12-1.1-1.67l.63-.41,1.1,1.67ZM531.56,199c-.38-.56-.77-1.1-1.14-1.63l.6-.44c.39.53.77,1.08,1.16,1.64Zm-2.32-3.25-1.2-1.59.6-.46,1.2,1.61Zm-2.43-3.17-1.25-1.55.58-.48c.41.49.83,1,1.26,1.57Zm-2.53-3.09L523,188l.56-.49c.41.45.85,1,1.32,1.52Zm-2.65-3c-.87-.94-1.38-1.43-1.38-1.44l.52-.53s.52.5,1.41,1.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.14,88.85c-.42-4.24-3.35-8.47-8.49-8.47s-8.06,4.23-8.48,8.47c-.65,6.55,3.77,12.49,8.48,17.9C494.37,101.34,498.79,95.4,498.14,88.85Zm-8.49,4.71a4.65,4.65,0,1,1,4.65-4.64A4.65,4.65,0,0,1,489.65,93.56Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.54,188c-.42-4.24-3.35-8.47-8.49-8.47s-8.06,4.23-8.48,8.47c-.65,6.55,3.77,12.49,8.48,17.9C569.77,200.45,574.19,194.51,573.54,188Zm-8.49,4.71A4.65,4.65,0,1,1,569.7,188,4.65,4.65,0,0,1,565.05,192.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.56,169.54c-.42-4.24-3.35-8.47-8.49-8.47s-8.06,4.23-8.48,8.47c-.65,6.55,3.77,12.49,8.48,17.9C523.79,182,528.21,176.09,527.56,169.54Zm-8.49,4.71a4.65,4.65,0,1,1,4.65-4.65A4.65,4.65,0,0,1,519.07,174.25Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.86,122.43c-.42-4.25-3.35-8.47-8.49-8.47s-8.06,4.22-8.48,8.47c-.65,6.55,3.77,12.49,8.48,17.9C676.09,134.92,680.51,129,679.86,122.43Zm-8.49,4.71a4.65,4.65,0,1,1,4.65-4.65A4.65,4.65,0,0,1,671.37,127.14Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.44,264.05c-.42-4.25-3.35-8.47-8.49-8.47s-8.06,4.22-8.48,8.47c-.65,6.55,3.77,12.48,8.48,17.9C552.67,276.53,557.09,270.6,556.44,264.05ZM548,268.76a4.65,4.65,0,1,1,4.66-4.65A4.65,4.65,0,0,1,548,268.76Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-49"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.38,
    cy: 433.07,
    rx: 327.88,
    ry: 17.89,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.4 399.61 115.26 399.37 201.11 399.28 372.83 399.12 544.55 399.28 630.4 399.37 716.26 399.61 630.4 399.86 544.55 399.95 372.83 400.11 201.11 399.94 115.26 399.86 29.4 399.61",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.18,399.6s-1.84-8.6-5.52-9.93-5.92,2.54-5.92,2.54-.87-8.22-6.09-10.68-9.13,2.58-9.13,2.58-4-10.42-11.16-10.42S98.6,388.94,98.6,388.94s-4.22-4.55-8.55-2-4.33,12.64-4.33,12.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,399.6H218.91s2.13-9.12,6.42-9.77,6.29,3.59,6.29,3.59-.2-12.72,7.81-14.89,14.73,9.07,14.73,9.07,5-6.41,11.87-6,8.58,11,8.58,11S280.85,388.92,283.6,399.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55,399.6h-34s.08-5.07,3.42-6.42a4.57,4.57,0,0,1,5.34,1.28s1.37-9.32,7.6-9.32,9.23,8,9.23,8a4.77,4.77,0,0,1,4.86-2C94.41,391.66,94.55,399.6,94.55,399.6Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Truck--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.3,190.62l8.37,185.8H530L514.23,301l-50.76-16a9.52,9.52,0,0,1-5.76-5.66l-30.35-77.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.08 210.18 389.88 277.21 444.85 282.36 421.16 212.63 386.08 210.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.16 246.9 389.03 262.19 405.51 278.67 421.42 280.17 388.16 246.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.32 210.97 432.57 246.22 428.87 235.29 405.08 211.5 397.32 210.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.53 218.06 386.63 219.91 442.68 275.96 441.77 273.3 386.53 218.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.35 267.83 389.45 269.69 397.7 277.94 399.64 278.12 389.35 267.83",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "386.08 210.18 421.16 212.63 444.85 282.36 441.17 282.01 418.78 216.09 386.25 213.12 386.08 210.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.65,
    y: 286.66,
    width: 1,
    height: 86.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.93,301.2l-12.39-2,7.22,25.51,6.38-.67a2.63,2.63,0,0,0,2.35-2.82l-1.35-17.66A2.66,2.66,0,0,0,520.93,301.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.67,264.34c-3,2.53-.29,25.29,1.82,24.9s6.64-1.25,8.46-2.69,12.12-19.86,9.62-23.68S454,262.39,451.67,264.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.67,264.34c-3,2.53-.29,25.29,1.82,24.9s6.64-1.25,8.46-2.69,12.12-19.86,9.62-23.68S454,262.39,451.67,264.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.81 296.78 392.94 296.78 392.94 291.48 411.81 292.51 411.81 296.78",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.46 376.42 60.33 376.42 76.9 153.13 362.18 137.99 373.46 376.42",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62,313a2,2,0,0,1,2.65-.26,9.68,9.68,0,0,0,6.42,2.76,8.81,8.81,0,0,0,4.68-1.32,4.28,4.28,0,0,0,2-2.58,1.87,1.87,0,0,0-.11-1.15,2.69,2.69,0,0,0-.92-1.06,12.06,12.06,0,0,0-4.64-1.74h-.08a17.63,17.63,0,0,1-4.35-1.4,6,6,0,0,1-2.87-2.8,5.06,5.06,0,0,1-.29-2.91,8.21,8.21,0,0,1,3.83-5.23,12,12,0,0,1,6.52-1.92c3.47,0,5.68,1.7,7.3,2.88a1.73,1.73,0,0,1,.07,2.54,1.92,1.92,0,0,1-2.61.52c-1.63-1.18-3.21-2.29-5.39-2.25a7.67,7.67,0,0,0-4.27,1.18,3.77,3.77,0,0,0-1.77,2.28,1.5,1.5,0,0,0,.11,1,2.38,2.38,0,0,0,.78.92,10.59,10.59,0,0,0,4.23,1.58H138a17.14,17.14,0,0,1,4.71,1.51,6.52,6.52,0,0,1,3,3,5.2,5.2,0,0,1,.29,3.1,8.75,8.75,0,0,1-4,5.56,13.05,13.05,0,0,1-7,2,12.67,12.67,0,0,1-8.58-3.61A1.83,1.83,0,0,1,126.62,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,308.3l-1.55,8.84a2.51,2.51,0,0,1-2.39,2,1.65,1.65,0,0,1-1.66-2l3.8-21.74a2.59,2.59,0,0,1,2.43-2,1.65,1.65,0,0,1,1.66,2l-1.55,8.84h9.54l1.55-8.84a2.58,2.58,0,0,1,2.4-2,1.67,1.67,0,0,1,1.69,2l-3.83,21.74a2.55,2.55,0,0,1-2.4,2,1.67,1.67,0,0,1-1.69-2l1.55-8.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.93,319.21a1.67,1.67,0,0,1-1.69-2l3.83-21.74a2.58,2.58,0,0,1,2.4-2,1.67,1.67,0,0,1,1.69,2l-3.83,21.74A2.57,2.57,0,0,1,181.93,319.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.22,317.11l3.83-21.75a2.58,2.58,0,0,1,2.4-2H204a6.44,6.44,0,0,1,6.53,7.88,9.87,9.87,0,0,1-9.29,7.92h-4.57l-1.4,8a2.55,2.55,0,0,1-2.4,2A1.66,1.66,0,0,1,191.22,317.11Zm12.12-19.68h-4.57l-1.32,7.62H202a4.79,4.79,0,0,0,4.5-3.83A3.1,3.1,0,0,0,203.34,297.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.7,317.11l3.84-21.75a2.58,2.58,0,0,1,2.39-2h6.6a6.44,6.44,0,0,1,6.52,7.88,9.86,9.86,0,0,1-9.29,7.92h-4.57l-1.4,8a2.55,2.55,0,0,1-2.39,2A1.67,1.67,0,0,1,212.7,317.11Zm12.13-19.68h-4.57l-1.33,7.62h4.53a4.79,4.79,0,0,0,4.5-3.83A3.09,3.09,0,0,0,224.83,297.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,319.21a1.68,1.68,0,0,1-1.7-2l3.84-21.74a2.58,2.58,0,0,1,2.39-2,1.67,1.67,0,0,1,1.7,2l-3.83,21.74A2.57,2.57,0,0,1,236.14,319.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,295.51a2.51,2.51,0,0,1,1.18-1.73,1.84,1.84,0,0,1,2.72.44l9.07,16.66,2.69-15.37a2.58,2.58,0,0,1,2.4-2,1.67,1.67,0,0,1,1.69,2l-3.83,21.63a2.49,2.49,0,0,1-2.4,2,1.66,1.66,0,0,1-1.4-.7,2,2,0,0,1-.14-.26l-9-16.51-2.72,15.44a2.5,2.5,0,0,1-2.4,2,1.64,1.64,0,0,1-1.66-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.46,306.23a16.24,16.24,0,0,1,15.48-12.89,11.22,11.22,0,0,1,7.71,2.8,2,2,0,0,1-.15,2.83,2.12,2.12,0,0,1-2.91.37,8,8,0,0,0-5.38-1.95,10.86,10.86,0,0,0-6.93,2.62,10.5,10.5,0,0,0-3.72,6.22,7.29,7.29,0,0,0,1.54,6.19,7.66,7.66,0,0,0,6,2.62,10.54,10.54,0,0,0,5.16-1.4l.88-4.9H287a1.65,1.65,0,0,1-1.66-2,2.49,2.49,0,0,1,2.4-2h7.11a1.66,1.66,0,0,1,1.7,2l-1.4,8a3.08,3.08,0,0,1-.19.56l-.11.22,0,0a2.32,2.32,0,0,1-.77.85,15.63,15.63,0,0,1-8.66,2.8h0C278.15,319.09,273.21,313.38,274.46,306.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.36,223l-42-35.53L114.61,200,124,289.21l149.14-19.59Zm-17.84.6a7,7,0,1,1-8.54-5.24A7.09,7.09,0,0,1,293.52,223.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,260.36l-4-33a3.09,3.09,0,0,1,2.71-3.45h.16l18.15-2.19a3.13,3.13,0,0,1,.75,6.21l-15.18,1.84L143,240l13.05-1.58a3.13,3.13,0,0,1,.75,6.22l-13.05,1.57,1.62,13.44a3.13,3.13,0,0,1-2.76,3.46A3.09,3.09,0,0,1,139.2,260.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.82,251.57a3.12,3.12,0,0,1-1.49,4.16,5.22,5.22,0,0,1-1.21.32h-.06a4.08,4.08,0,0,1-2.26-.35,5.5,5.5,0,0,1-2-1.74,15,15,0,0,1-2-6.58,4.79,4.79,0,0,0-1-2.33,5.36,5.36,0,0,0-1.87-1.42,11.08,11.08,0,0,0-3.3-1l-6.61.8,1.47,12.16a3.15,3.15,0,0,1-2.77,3.46,3.1,3.1,0,0,1-3.45-2.71l-4-33.05a3.06,3.06,0,0,1,2.71-3.45h.06l10-1.2A12.07,12.07,0,0,1,191.21,239a8.84,8.84,0,0,1,2.22,1.83,10.68,10.68,0,0,1,2.57,5.83,14.18,14.18,0,0,0,.63,3.27A3.06,3.06,0,0,1,198.82,251.57ZM188.26,230a5.82,5.82,0,0,0-6.47-5.12l-6.89.83,1.39,11.54,6.89-.84A5.79,5.79,0,0,0,188.26,230Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.08,252.05l-4-33.05a3.06,3.06,0,0,1,2.7-3.45H207l18.15-2.19a3.13,3.13,0,0,1,3.45,2.71,3.17,3.17,0,0,1-2.7,3.5l-15.18,1.84,1.24,10.25L225,230.06a3.13,3.13,0,0,1,.75,6.22l-13.05,1.57,1.24,10.31,15.18-1.84a3.13,3.13,0,0,1,.75,6.22l-18.14,2.19c-.12,0-.12,0-.12,0l-.05.06A3.08,3.08,0,0,1,208.08,252.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,248l-4-33a3.06,3.06,0,0,1,2.71-3.45h.17l18.14-2.19a3.13,3.13,0,0,1,3.46,2.71,3.18,3.18,0,0,1-2.71,3.5l-15.17,1.84,1.23,10.25,13.05-1.58a3.13,3.13,0,0,1,.75,6.22l-13,1.57,1.24,10.31,15.18-1.84a3.13,3.13,0,0,1,.75,6.22l-18.15,2.19c-.11,0-.12,0-.12,0l-.05.06A3.1,3.1,0,0,1,241.28,248Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.16,223.38a66.08,66.08,0,0,1,8.56,0,85.21,85.21,0,0,1,8.57.88,75.7,75.7,0,0,1,16.82,4.55,53.82,53.82,0,0,1,8,4.07c1.29.78,2.52,1.68,3.74,2.59l1.77,1.48c.58.5,1.12,1.06,1.68,1.59a33.26,33.26,0,0,1,5.67,7.5l1.07,2.13c.31.73.58,1.49.87,2.23a23.23,23.23,0,0,1,.71,2.24l.32,1.12.24,1.14a33.78,33.78,0,0,1,.75,9.36,35.24,35.24,0,0,1-1.86,9.18,43.29,43.29,0,0,1-9.55,15.39,59.05,59.05,0,0,1-13.89,10.79,55.11,55.11,0,0,1-16.14,6.2l-.23-.75a74.29,74.29,0,0,0,14.2-8.72A68.12,68.12,0,0,0,332.07,285a42,42,0,0,0,7.42-13.69,29.18,29.18,0,0,0,.66-14.92l-.18-.93-.26-.91a16.59,16.59,0,0,0-.55-1.81c-.22-.57-.42-1.16-.65-1.73l-.79-1.68a29.16,29.16,0,0,0-4.31-6.13,46.09,46.09,0,0,0-12.64-9.36,95.85,95.85,0,0,0-15.26-6.23A154.12,154.12,0,0,0,289.16,223.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.73 292.59 307.29 305.18 320.32 310.68 300.91 307.5 313.73 292.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.46 376.41 60.33 376.41 61.22 364.43 371.98 344.92 373.46 376.41",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.75 386.46 536.98 386.46 536.98 372.23 536.98 372.23 58.75 372.23 58.75 386.46",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "546.93 365.39 499.23 368.32 499.23 368.32 499.23 388.62 550.49 388.62 550.49 388.62 546.93 365.39",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.34 388.62 79.34 368.75 49.24 365.64 45.54 388.62 79.34 388.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.12,391.48l-9.9-1.45c1.89-12.87,13.17-37.22,42.38-37.22s40.27,24.39,42,37.28l-9.91,1.34,5-.67-5,.68c-.16-1.17-4.36-28.63-32.1-28.63C120.64,362.81,116.29,390.31,116.12,391.48Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,358.88c-46.63,0-46.7,72.47,0,72.47S195.12,358.88,148.41,358.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,378.67c-21.16,0-21.2,32.89,0,32.89S169.61,378.67,148.41,378.67Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.44,391.5,385.55,390c1.88-12.87,13.16-37.22,42.38-37.22s40.26,24.39,42,37.28L460,391.43l5-.67-5,.68c-.17-1.17-4.37-28.63-32.1-28.63S395.62,390.33,395.44,391.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.91,358.88c-46.63,0-46.7,72.47,0,72.47S474.62,358.88,427.91,358.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.91,378.67c-21.16,0-21.2,32.89,0,32.89S449.11,378.67,427.91,378.67Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.16,
    y: 378.25,
    width: 52.73,
    height: 58.4,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.16,
    y: 378.25,
    width: 52.73,
    height: 58.4,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.93,
    y: 378.25,
    width: 27.23,
    height: 58.4,
    transform: "translate(1123.09 814.9) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.93,
    y: 378.25,
    width: 27.23,
    height: 58.4,
    transform: "translate(1123.09 814.9) rotate(180)",
    style: {
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "597.05 390.87 598.17 390.87 599.01 390.87 599.49 389.9 600.16 390.87 601.07 388.87 601.93 390.87 604.4 390.87 605.52 390.87 605.93 389.54 606.32 390.87 607.05 390.87 607.05 378.25 597.05 378.25 597.05 390.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.81,432.63q3-6.24,6-12.5l5.91-12.56L567.54,395q2.91-6.31,5.74-12.68-3,6.24-6,12.5l-5.91,12.56L555.55,420Q552.66,426.27,549.81,432.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.81,382.27q2.84,6.36,5.74,12.68l5.83,12.62,5.91,12.56q3,6.27,6,12.5-2.84-6.36-5.74-12.68l-5.83-12.62-5.91-12.56Q552.83,388.5,549.81,382.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.57,
    y: 319.85,
    width: 52.73,
    height: 58.4,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 599.57,
    y: 319.85,
    width: 52.73,
    height: 58.4,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.34,
    y: 319.85,
    width: 27.23,
    height: 58.4,
    transform: "translate(1171.92 698.11) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.34,
    y: 319.85,
    width: 27.23,
    height: 58.4,
    transform: "translate(1171.92 698.11) rotate(180)",
    style: {
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "621.47 332.47 622.58 332.47 623.42 332.47 623.9 331.5 624.57 332.47 625.48 330.47 626.34 332.47 628.81 332.47 629.94 332.47 630.35 331.14 630.73 332.47 631.46 332.47 631.46 319.85 621.47 319.85 621.47 332.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.22,374.23q3-6.23,6-12.5l5.91-12.56L592,336.56q2.91-6.33,5.75-12.68-3,6.22-6,12.49l-5.91,12.56L580,361.55Q577.06,367.87,574.22,374.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.22,323.88q2.85,6.36,5.74,12.68l5.83,12.61,5.91,12.56q3,6.27,6,12.5-2.85-6.36-5.75-12.68l-5.83-12.62-5.91-12.56Q577.26,330.1,574.22,323.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.91,
    y: 378.25,
    width: 52.73,
    height: 58.4,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.91,
    y: 378.25,
    width: 52.73,
    height: 58.4,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.68,
    y: 378.25,
    width: 27.23,
    height: 58.4,
    transform: "translate(1258.59 814.9) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 615.68,
    y: 378.25,
    width: 27.23,
    height: 58.4,
    transform: "translate(1258.59 814.9) rotate(180)",
    style: {
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.8 390.87 665.92 390.87 666.76 390.87 667.24 389.9 667.91 390.87 668.82 388.87 669.68 390.87 672.15 390.87 673.28 390.87 673.68 389.54 674.07 390.87 674.8 390.87 674.8 378.25 664.8 378.25 664.8 390.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.56,432.63q3-6.24,6-12.5l5.91-12.56L635.29,395q2.91-6.31,5.74-12.68-3,6.24-6,12.5l-5.91,12.56L623.3,420Q620.41,426.27,617.56,432.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.56,382.27q2.84,6.36,5.74,12.68l5.83,12.62L635,420.13q3,6.27,6,12.5-2.84-6.36-5.74-12.68l-5.83-12.62-5.91-12.56Q620.58,388.5,617.56,382.27Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.74,437.34c1.92.61,56.51-.09,58.57-1.44.79-.5,1.15-8.46,1.31-18.09v-.3c0-2,.06-4,.07-6.1,0-.29,0-.57,0-.86l-2.65-28.32-36.52.37,3.6,28,0,1.11.22,5.81,0,.6s-20.78,9.61-22.89,11.34S487.83,436.73,489.74,437.34Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.74,437.34c1.92.61,56.51-.09,58.57-1.44.79-.5,1.15-8.46,1.31-18.09v-.3c0-2,.06-4,.07-6.1,0-.29,0-.57,0-.86l-35.57.1,0,1.11.22,5.81,0,.6s-20.78,9.61-22.89,11.34S487.83,436.73,489.74,437.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.74,437.33c1,.32,15.81.29,30.31,0,2.91-.05,5.81-.12,8.58-.2,10.33-.28,18.88-.71,19.67-1.22s1.14-8.24,1.3-17.69c0-.13,0-.27,0-.4s0-.21,0-.31h0l-35.18.07v.6s-20.77,9.61-22.88,11.33S487.82,436.72,489.74,437.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.33,435.21c9.2-.34,46.34-.87,55.46-.51.07,0,.07.05,0,.06-9.11.54-46.25.76-55.46.6C490.14,435.36,490.14,435.22,490.33,435.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.48,417.72c3.61-.72,8-.22,10.85,2.32.1.1,0,.25-.16.22a50.87,50.87,0,0,0-10.67-2.08A.23.23,0,0,1,510.48,417.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.88,419.33c3.62-.72,8-.22,10.85,2.32.11.1,0,.25-.15.22a51,51,0,0,0-10.68-2.08A.23.23,0,0,1,507.88,419.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.29,420.94c3.61-.72,8.05-.22,10.85,2.32.11.1,0,.25-.15.21a51.59,51.59,0,0,0-10.68-2.07A.23.23,0,0,1,505.29,420.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.05,437.32c2.91-.05,5.81-.12,8.58-.2,10.33-.28,18.88-.71,19.67-1.22s1.14-8.24,1.3-17.69c0-.13,0-.27,0-.4s0-.21,0-.31h0C544.76,420.88,527.77,432.19,520.05,437.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.85,417.69h39.32s-7.92-91.82-7.61-93.43c.39-2.05,2.72-11.34,5.8-23.49,1-3.8,2-7.87,3.1-12.1,2.93-11.42,6.17-23.9,9-34.77L569,225H535.64s-3.88,12.31-8.77,28.33c-8,26-18.63,61.85-19.68,70.56C505.48,337.93,511.85,417.69,511.85,417.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.74,411c6-.12,4.28-.17,10.29-.23,2.93,0,22.25-.19,25,.26a.06.06,0,0,1,0,.12c-2.74.46-22.06.29-25,.26-6-.06-4.28-.11-10.29-.23C513.63,411.16,513.63,411,513.74,411Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.31,318.65c1.29-5.68,3.22-11.25,4.89-16.83q5.12-17,10.29-34,2.58-8.49,5.18-17,1.32-4.29,2.65-8.57c.88-2.79,1.87-5.56,2.66-8.37.32-1.15.5-.52.09.94-.83,2.93-1.65,5.87-2.5,8.79Q557,252.33,554.45,261q-5.1,17.28-10.31,34.53-2.6,8.65-5.2,17.3a70.77,70.77,0,0,0-2.13,8.37,38.85,38.85,0,0,0-.35,8.95c.38,6,1.08,12,1.63,18s1.12,12,1.67,18q1.66,18,3.3,35.91c.13,1.52.27,3,.38,4.55,0,.51-.73.47-.78,0-1.3-11.83-2.29-23.7-3.4-35.55s-2.21-23.59-3.31-35.39c-.28-3-.59-5.92-.6-8.9A36.94,36.94,0,0,1,536.31,318.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.57,225c2.32,17.9,6.73,51.45,9.94,75.79C557,271.28,569.11,225,569.11,225Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.39,437.86c1.91.63,56.5.12,58.57-1.22.79-.5,1.18-8.46,1.38-18.09v-.3c0-2,.08-4,.09-6.1,0-.28,0-.57,0-.85.13-13.9-.87-28.32-.87-28.32l-35.69.23,1,28.06,0,1.11.2,5.81,0,.59s-20.81,9.54-22.93,11.26S529.48,437.25,531.39,437.86Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.39,437.86c1.91.63,56.5.12,58.57-1.22.79-.5,1.18-8.46,1.38-18.09v-.3c0-2,.08-4,.09-6.1,0-.28,0-.57,0-.85l-35.56,0,0,1.11.2,5.81,0,.59s-20.81,9.54-22.93,11.26S529.48,437.25,531.39,437.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.39,437.86c1.91.63,56.5.12,58.57-1.22.79-.5,1.18-8.46,1.38-18.09v-.3l-35.22-.06,0,.59s-20.81,9.54-22.93,11.26S529.48,437.25,531.39,437.86Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,435.74c9.2-.31,46.34-.7,55.45-.31.08,0,.08.05,0,.06-9.11.51-46.25.59-55.45.4C531.8,435.89,531.79,435.75,532,435.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.2,418.32c3.61-.71,8-.19,10.84,2.36.1.1,0,.25-.16.22a50.22,50.22,0,0,0-10.66-2.12A.23.23,0,0,1,552.2,418.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.6,419.92c3.61-.71,8-.19,10.84,2.36.11.1,0,.25-.15.22a50.43,50.43,0,0,0-10.67-2.12A.23.23,0,0,1,549.6,419.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,421.52c3.61-.71,8-.19,10.84,2.36.11.1,0,.25-.15.22A50.43,50.43,0,0,0,547,422,.23.23,0,0,1,547,421.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.45,225s.76,15.94,4.41,28.57c.3,1,.61,2.07,1,3.06a59,59,0,0,1,9.6,4.93s.38,12.83.77,27.13c.42,16,.87,33.83.77,37.61-.33,14.16,1.77,92,1.77,92l39.31.16s-7.11-86.92-7.06-92.1c.08-8.34-1.9-45.17-3.43-72-.93-16.55-1.7-29.31-1.7-29.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.5,411.28c6-.1,4.28-.16,10.29-.19,2.94,0,22.25-.1,25,.36a.06.06,0,0,1,0,.12c-2.75.45-22.06.2-25,.16-6-.09-4.28-.13-10.29-.28A.09.09,0,0,1,556.5,411.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,230.68c.72,21.93,1.49,43.86,2.47,65.78s2.31,44,4.15,65.92c1,12.26,2,29.51,3.32,41.74,0,.08-.12.11-.13,0-2.86-21.75-4.45-48.65-5.86-70.54s-2.36-43.81-3.11-65.73c-.42-12.4-.74-24.81-1.12-37.21C578.69,230.49,579,230.5,579,230.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.6,255.66a71.94,71.94,0,0,1,11.24,5.88.13.13,0,0,1-.12.23c-3.79-1.84-7.66-3.61-11.35-5.66A.25.25,0,0,1,540.6,255.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.33,236.79c.34,1.83.78,3.64,1.18,5.46s.64,3.44,1.09,5.13a8.76,8.76,0,0,0,2.39,4.29c.67.63,1.41,1.18,2.12,1.75l1.2.91c0-.24-.09-.49-.14-.74-.12-.69-.24-1.38-.35-2.08-.26-1.54-.51-3.08-.74-4.62-.47-3-.89-6.1-1.53-9.1a.1.1,0,0,1,.19,0c.76,3,1.59,5.92,2.25,8.92.32,1.47,1.47,8.74,1.53,9.25s.09,1.07.11,1.6a6.35,6.35,0,0,1,0,1.63.13.13,0,0,1-.24,0h0a6.11,6.11,0,0,1-.46-1.58c-.14-.52-.25-1-.35-1.57,0-.19-.06-.39-.08-.58-.72-.44-1.39-1-2.06-1.5s-1.45-1-2.13-1.6a8.12,8.12,0,0,1-2.61-4.08,29.77,29.77,0,0,1-.86-5.22c-.23-2.07-.4-4.14-.69-6.2C538.13,236.72,538.31,236.67,538.33,236.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.35,178.31c-1.77,6.89-8.81,22.62-20.64,35.6-4.57,5-40.75,10.31-44.57,9.22-2.68-.77-10.52-23.91-8-25.85,4.79-3.65,38.73.59,40.07-.29,2.06-1.35,15.49-12.28,23.86-22.25C548.22,167.47,554.29,166.84,551.35,178.31Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.62,198.91l-21.88-6.43s17.43-18,24-21.9c7.45-4.34,8,.42,6,8.37S543.62,198.91,543.62,198.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,189.5c.79.1,7.64,2,9.12,2.44s7.55,2.21,9,2.79a.06.06,0,0,1,0,.11c-1.57-.29-7.69-2.05-9.21-2.47s-8.25-2.45-9-2.77C525.86,189.57,525.9,189.49,526,189.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.18,196.42l8.44,2.48s6.16-12,8.19-20c1.48-5.81,1.56-9.92-1.41-10Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.5,240.83l-56.74-.27c0,1.12,12.31-63.42,18.24-71.15,1.27-1.66,9.94-3.75,13.85-.1C578,185.27,585.5,241.55,585.5,240.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "541.44 187.08 548.69 187.58 548.25 197.15 543.27 198.47 540.42 196.21 541.44 187.08",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.8,177.16c2.7.65,6.69-4.47,8.64-8.33.13-.26-.36-3-.8-6.32-.25-2-.49-4.28-.56-6.36,0-.43-12.93,3.6-12.93,3.6a32.88,32.88,0,0,1,1.52,7.94,4,4,0,0,1-.06.86s0,.08,0,.14C546.39,170.32,547.91,176.46,550.8,177.16Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.61,168.55s0,.09,0,.14a8.41,8.41,0,0,0,1.34,0c7.66-.42,9.37-10.09,9.68-12.54-2.31.41-12.47,3.58-12.47,3.58a33.2,33.2,0,0,1,1.53,7.94A4.68,4.68,0,0,1,546.61,168.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.5,140.56c1.1,4.71-2.23,17.88-5.71,20.63-5,4-12.86,3.88-16.14-2.08-3.18-5.78,1.46-22.86,5.31-25.32C549.62,130.17,558.87,133.61,560.5,140.56Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.28,147.67s.06.06.05.1c-.25.88-.38,1.93.35,2.42,0,0,0,.06,0,.05C546.71,149.86,546.91,148.47,547.28,147.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.31,146.94c1.45.25.85,3.14-.49,2.91S547.09,146.74,548.31,146.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.46,146.75s-.08,0-.09.06c-.16.91-.49,1.91-1.36,2,0,0,0,.05,0,.05C542,149,542.45,147.63,542.46,146.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.85,145.65c-1.42-.41-2.13,2.46-.81,2.83S543,146,541.85,145.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.72,145.86a11.06,11.06,0,0,1-1-.63,2,2,0,0,1-.94-.84.64.64,0,0,1,.25-.72,1.59,1.59,0,0,1,1.57.16,2.25,2.25,0,0,1,1.08,1.23A.67.67,0,0,1,549.72,145.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,144a9.71,9.71,0,0,0,1.21-.06,2,2,0,0,0,1.23-.3.62.62,0,0,0,.11-.75,1.55,1.55,0,0,0-1.45-.6,2.32,2.32,0,0,0-1.53.57A.67.67,0,0,0,541,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.66,156.16c-.26.16-.53.41-.86.37a2.43,2.43,0,0,1-.92-.43s-.06,0,0,0a1.23,1.23,0,0,0,1,.72,1,1,0,0,0,.87-.64A.05.05,0,0,0,546.66,156.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.27,153.28a3.1,3.1,0,0,1-2.32.94,3.78,3.78,0,0,1-1.1-.18,1.29,1.29,0,0,1-.21-.06l-.19-.08a.22.22,0,0,1-.14-.23h0a.29.29,0,0,1,0-.09h0l0-.07c.13-.7.41-1.73.41-1.73-.28.07-1.68.38-1.59,0a47.53,47.53,0,0,1,3.09-9,.09.09,0,0,1,.16.06c-.65,2.86-1.8,5.59-2.5,8.45a5.55,5.55,0,0,1,1.53-.14c.09.05-.58,2-.62,2.31v0a4.29,4.29,0,0,0,3.36-.33C546.28,153.15,546.34,153.22,546.27,153.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.33,153.78a3.7,3.7,0,0,0,1.21,1.42,1.72,1.72,0,0,0,1,.27c.75-.05.91-.7.89-1.29a4,4,0,0,0-.14-.92A4.81,4.81,0,0,1,543.33,153.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.54,155.2a1.72,1.72,0,0,0,1,.27c.75-.05.91-.7.89-1.29A1.73,1.73,0,0,0,544.54,155.2Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.14,137.79c.73-1,1.53-2.07,2.26-2.15s.84,1.67,2.37,2.1c2.07.57,3.49-1.15,6.47-.75,4.28.57,5.42,4.48,4.29,10.49-1,5.37,2.13,6.53,2.13,6.53s4.37-11.39,1.85-16-9.8-7.88-15.69-5.2C542.67,133.8,541.14,137.79,541.14,137.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.39,151.35s3.38-4,5.24-2.8-.94,7.29-3.31,7.94a2.34,2.34,0,0,1-3-1.52Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.78,150.27a0,0,0,0,1,0,.06,5.94,5.94,0,0,0-3.37,3.42,1.3,1.3,0,0,1,2-.18s0,.09,0,.08a1.43,1.43,0,0,0-1.62.36,6.87,6.87,0,0,0-.87,1.21c-.09.14-.34,0-.27-.12l0,0C556.72,153,558.57,150.28,560.78,150.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,135.2c1.3-.06,8.2,1.49,11.06,3.44s7.52,7.51,7.76,7.8,3.89-10.87-5-14.76C546.2,127.44,542,135.2,542,135.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.41,145.87s-4.56-9.28-7.61-11.79-10.48-5-15.6-3.88c-4,.91,4.07,7.39,4.07,7.39a2.6,2.6,0,0,1,1.77-1.5c2.48-.47,6.71,1.08,9,2.4C555,140.15,560.41,145.87,560.41,145.87Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.41,145.87s-4.56-9.28-7.61-11.79-10.48-5-15.6-3.88c-4,.91,4.07,7.39,4.07,7.39a2.6,2.6,0,0,1,1.77-1.5c2.48-.47,6.71,1.08,9,2.4C555,140.15,560.41,145.87,560.41,145.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.92,
    y: 206.16,
    width: 44.75,
    height: 49.56,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.92,
    y: 206.16,
    width: 44.75,
    height: 49.56,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.81,
    y: 206.16,
    width: 23.11,
    height: 49.56,
    transform: "translate(1062.72 461.88) rotate(180)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.81,
    y: 206.16,
    width: 23.11,
    height: 49.56,
    transform: "translate(1062.72 461.88) rotate(180)",
    style: {
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.5 216.87 562.44 216.87 563.15 216.87 563.56 216.04 564.13 216.87 564.9 215.17 565.63 216.87 567.73 216.87 568.69 216.87 569.03 215.74 569.36 216.87 569.98 216.87 569.98 206.16 561.5 206.16 561.5 216.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.4,252.3q2.57-5.28,5.09-10.6l5-10.66,5-10.71q2.46-5.36,4.87-10.76-2.57,5.3-5.08,10.61l-5,10.66-5,10.71Q523.81,246.91,521.4,252.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.4,209.57q2.42,5.4,4.87,10.76l5,10.71,5,10.66q2.52,5.33,5.08,10.6-2.4-5.38-4.87-10.76l-5-10.7-5-10.66Q524,214.86,521.4,209.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.17,173.55c10.92,8.21,32.1,26.61,34,36.56,2.43,13.06-8.69,38.75-13.44,43.71-3.2,3.35-17.3-9-18.15-12s10.61-23.87,10.7-26.26-14.56-24.26-20.92-34C555.3,169.31,561.93,166.59,571.17,173.55Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.92,243.54c1-1.16.4-1.69-2.27-1.17s-12.76,4.83-14,1.18,13.12-9.53,17.62-10.05a72.84,72.84,0,0,1,12,.2C578.72,235.41,572.9,240.13,567.92,243.54Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593,252.16c-4.52,7.54-17.63,12.29-27.41,12.47a4.83,4.83,0,0,1-3-.9c-4.38.16-5.77-1.86-5.77-1.86-4.13-1.11-5.26-3.37-5.26-3.37s-5.15.13-5.75-3c-.67-3.48,6.69-3,10.9-5.18,9.66-5.05,22-14.92,24.61-16.66Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.51,252.18a48.89,48.89,0,0,1-18.92,6.22.09.09,0,0,0,0,.17,37,37,0,0,0,19-6.26C570.7,252.22,570.65,252.11,570.51,252.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.4,257.56c-2.87,1.24-7.93,3.38-17.63,4.2,0,0,0,.06,0,.06a33.23,33.23,0,0,0,17.69-4.12C574.63,257.61,574.59,257.48,574.4,257.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.44,260.5a52.38,52.38,0,0,1-13.87,3.2s0,.06,0,.06c6.38-.15,8.67-.92,14-3.1C576.71,260.58,576.63,260.42,576.44,260.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.79,197.83l20.72-9.53s-19.86-15.32-27-18.18c-8-3.22-7.9,1.58-4.75,9.15S571.79,197.83,571.79,197.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.9,186c-.77.22-7.27,3.09-8.67,3.74s-7.15,3.27-8.54,4.07c-.06,0,0,.13,0,.1,1.51-.51,7.32-3.14,8.76-3.78s7.81-3.61,8.46-4C588,186,588,185.94,587.9,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.42,197.06c-.64.24-1.63.66-1.63.66-1.53-2.8-3.36-5.46-5-8.18s-3.44-5.5-5.15-8.25a0,0,0,0,0-.07,0c.88,1.62,1.75,3.23,2.64,4.84l-.44-.54c-.52-.65-1.06-1.28-1.55-1.94,0-.05-.13,0-.09.06a20.76,20.76,0,0,0,1.42,2.05c.38.45.78.88,1.19,1.3.51.91,1,1.83,1.56,2.74,1.65,2.78,3.28,6,5.14,8.63,0,0,1.41-.8,2.08-1.28C573.59,197.14,573.52,197,573.42,197.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.67 228.06 481.59 230.87 470.15 184.26 504.23 181.45 515.67 228.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.08 184.93 479.93 186.25 478.67 181.1 494.83 179.79 496.08 184.93",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.16 180.09 489.17 180.25 488.59 177.88 483.75 178.27 484.33 180.65 482.35 180.81 481.29 176.49 490.13 175.77 491.16 180.09",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.16,205.45a3.71,3.71,0,0,0,2.88,3.38s-2.78,2.27-2,5.15c.4,1.48,3.12,2.14,3.12,2.14a4.42,4.42,0,0,0-1.29,4.43c.68,2,3.31,2.36,3.31,2.36s-1.21,2.8.14,4.62c2.74,3.69,20.47-.32,21.73-7.47.59-3.34-3.69-2.12-3.69-2.12s5.73-3.23,5-6.91-6.2-1.76-6.2-1.76,5.53-3.18,4.38-6.92-6.33-1-6.33-1,3.34-3.56,1.81-6.22c-2.53-4.39-10.14,3.55-14.24,3.51l-1.61-6.08S464.82,202.23,465.16,205.45Z",
    style: {
      fill: "rgb(255, 196, 192)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.59,223a0,0,0,1,0,0,.09,31.48,31.48,0,0,0,18-5.22c.16-.12,0-.44-.16-.34A64.92,64.92,0,0,1,471.59,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.09,216.17c-.07,0,0,.13,0,.13a29.54,29.54,0,0,0,19.31-6.92c.18-.16.18-.5,0-.32C484.57,212,474.92,215.37,469.09,216.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.51,200.84c-5.33,4.39-11.52,6.62-18.21,8-.09,0-.05.13,0,.14,3.46.21,7.63-1.11,10.79-2.42a18.2,18.2,0,0,0,7.55-5.54C486.74,200.93,486.62,200.75,486.51,200.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.56,170.9a17.32,17.32,0,0,0,.83,2.94,17.55,17.55,0,0,0,1.28,2.74,8.34,8.34,0,0,0,1.83,2.27,2.79,2.79,0,0,0,1.19.57,2.74,2.74,0,0,0,1.27-.28,13.12,13.12,0,0,0,4.59-3.7c.33-.38.64-.78,1-1.17s.6-.83.89-1.25.57-.84.85-1.27.53-.87.81-1.3a24,24,0,0,1-3,5.4,12.16,12.16,0,0,1-4.78,4.05,3.47,3.47,0,0,1-1.71.3,3.2,3.2,0,0,1-1.54-.76,7.71,7.71,0,0,1-1.89-2.57A14.64,14.64,0,0,1,545.56,170.9Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.16748299.svg";
export { ForwardRef as ReactComponent };